<template>
    <div class="container mt-4" v-if="order"> 
      <b-row>
        <b-col>
          <h3>Order #{{order.Number}}</h3>
          </b-col>
        <b-col class="text-right">
          <h3>{{ order.Date | moment("dddd, MMMM Do YYYY")}}</h3>
        </b-col>
      </b-row> 
        <b-row class="mt-4">
          <b-col>
            <h5>Billing Address</h5>
            {{order.BillingAddressFullName}} <br/>
            {{order.BillingAddress1}} <br/>
            {{order.BillingAddress2}} <br/>
            {{order.BillingAddress3}} <br/>
            {{order.BillingCity}} <br/>
            {{order.BillingState}} {{order.BillingPostcode}} <br/>
          </b-col>
          <b-col v-if="order.__type == 'MyobInvoice'">
            <h5>Ship To</h5>
            {{order.ShipToAddress}}
          </b-col>
          <b-col v-else>
            <h5>Shipping Address</h5>
            {{order.ShippingAddressFullName}} <br/>
            {{order.ShippingAddress1}} <br/>
            {{order.ShippingAddress2}} <br/>
            {{order.ShippingAddress3}} <br/>
            {{order.ShippingCity}} <br/>
            {{order.ShippingState}} {{order.ShippingPostcode}} <br/>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-table striped hover :items="order.QuoteItems" :fields="LineFields">
            <template #cell(ItemNumber)="data">
              <b-link :to="{ name: 'ProductDetail', query: { number: data.item.ItemNumber }}">{{data.item.ItemNumber}}</b-link>
            </template>
          </b-table>
        </b-row>
    </div>
</template>

<script>
import store from "@/store.js";
import OrderHistoryService from "../services/OrderHistoryService";
import moment from 'moment'

function GetOrder(key, done) {
  OrderHistoryService.GetOrder(key)
    .then(response => {
        done(null, response.data);
    })
    .catch(() => {
      done("unable to get order");
    });
}

export default {
  name: "ViewOrder",
  data() {
    return {
        order: null,
        error: null
    };
  },
  computed: {
    LineFields() {
      
        return [
          { key: 'ItemNumber'}, 
          { key: 'Quantity'}
        ]
      
    },
  },
  beforeRouteEnter(to, from, next) {
    GetOrder(to.params.key, (err, order) => {
      next(vm => vm.setData(err, order));
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.order = null;
    GetOrder(to.params.key, (err, order) => {
      this.setData(err, order);
      next();
    });
  },
  methods: {
    setData(err, order) {
      if (err) {
        this.error = err.toString();
      } else {
        this.order = order;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/vieworder.vue